module.exports = __webpack_public_path__ + "img/10.4628d5de.jpg";